import { Images } from "../../Assets/Index";
import { useSelector } from "react-redux";
import { getLocalStorageItem } from "../../Utils";
import {
  Avatar,
  Button,
  DatePicker,
  Form,
  Image,
  Input,
  message,
  Upload,
} from "antd";
import { PiCameraPlusLight } from "react-icons/pi";
import { IoCaretBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { BiUser } from "react-icons/bi";
import { useEffect, useRef, useState } from "react";
import { useCommmonStore } from "../../Store/CommonReducer";
import { getProfile, updateProfile } from "./UserEndpoints";
const Profile = () => {
  const walletBalance = useSelector((state) => state.colorGame.walletBal);
  const withdrawAmount = useSelector((state) => state.colorGame.withdrawAmt);
  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");
  const [form] = Form.useForm();
  const { profileDetail, setProfileDetail } = useCommmonStore();
  const formref = useRef();
  const fileInputRef = useRef(null);
  const isValidPhone = /^\d{10}$/.test(mobile);
  const [btnLoading, setBtnLoading] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [image, setImage] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [binaryImage, setBinaryImage] = useState(null);
  const UserProfile = () => {
    getProfile()
      .then((res) => {
        if (res.status) {
          setProfileDetail(res.data);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    UserProfile();
  }, []);

  useEffect(() => {
    if (profileDetail) {
      formref.current.setFieldsValue({
        name: profileDetail?.user?.name ?? "",
        email: profileDetail?.user?.email ?? "",
        mobile: profileDetail?.user?.mobile ?? "",
        referral_code: profileDetail?.user?.referral_code ?? "",
        aadhar_no: profileDetail?.user?.aadhar_no ?? "",
        bank: profileDetail?.bankDetail?.bank ?? "",
        ifsc_code: profileDetail?.bankDetail?.ifsc_code ?? "",
        ac_no: profileDetail?.bankDetail?.ac_no ?? "",
        upi_id: profileDetail?.bankDetail?.upi_id ?? "",
        ac_holder_name: profileDetail?.bankDetail?.ac_holder_name ?? "",
        image: profileDetail?.bankDetail?.image ?? null,
      });
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileDetail]);

  const handleUpdate = (val) => {
    console.log(val);
    let data = { ...val };
    setBtnLoading(true);
    const formdata = new FormData();
    Object.keys(data).map((key) => formdata.append(key, data[key]));
    formdata.append("image", binaryImage);
    updateProfile(formdata)
      .then((res) => {
        if (res.status) {
          message.success(res.message, 3);
          UserProfile();
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = () => {
    setPageLoader(true);
    const file = fileInputRef.current.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        // setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
      const formdata = new FormData();
      formdata.append("image", file);
      formdata.append("name", form.getFieldValue("name"));
      formdata.append("aadhar_no", form.getFieldValue("aadhar_no") ?? " ");
      formdata.append(
        "ac_holder_name",
        form.getFieldValue("ac_holder_name") ?? " "
      );
      formdata.append("ac_no", form.getFieldValue("ac_no") ?? " ");
      formdata.append("bank", form.getFieldValue("bank") ?? " ");
      formdata.append("ifsc_code", form.getFieldValue("ifsc_code") ?? " ");

      // formdata.append("aadhar_no", formref.current.getFieldsValue().aadhar_no??" ");

      updateProfile(formdata)
        .then((res) => {
          if (res.status) {
            message.success(res.message, 3);
            UserProfile();
          }
        })
        .catch((err) => console.log(err))
        .finally(() => setPageLoader(false));
    }
  };
  const handleCustomReq = async ({ file, onSuccess, onError }) => {
    try {
      setBinaryImage(file);

      const dataUrl = await readFileAsDataUrl(file); // You already have this utility

      const newFile = {
        ...file,
        name: file.name,
        status: "done",
        uid: file.uid,
        thumbUrl: dataUrl,
        url: dataUrl,
      };

      // Update preview state and fileList
      setPreviewUrl(dataUrl); // <- You had a typo using `base64` which was not defined
      setImage([newFile]);

      // Update form field
      form.setFieldValue("image", dataUrl);

      onSuccess();
    } catch (error) {
      console.error(error);
      onError(error);
    }
  };

  const readFileAsDataUrl = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };
  return (
    <>
      <div className="flex justify-center pb-20 items-center bg-black rounded-lg">
        <div className="w-full ">
          <div className="flex justify-between bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f] px-8  py-2 gap-x-3 items-center ">
            <div className="text-white font-semibold flex  items-center gap-4 ">
              <IoCaretBack
                className="bg-[#ba7d13] h-7 w-7 rounded-lg cursor-pointer text-white"
                onClick={() => navigate("/home")}
              />
              <p className="text-xl font-normal custome">
                {getLocalStorageItem("userDetails")?.name}My Profile
              </p>
            </div>
            <div className="flex justify-between items-center">
              <img src={Images.Money} className="w-8 m-auto my-2" alt="money" />
              <p className="text-white text-sm  custome">
                ₹ {profileDetail?.user?.wallet_balance ?? 0}
              </p>
            </div>
          </div>
          <div className="overflow-y-scroll h-[90vh]">
            {" "}
            <div>
              <div className="m-16 bg-black ">
                <div className="text-center">
                  {form.getFieldValue("image") || profileDetail?.user?.image ? (
                    <Image
                      src={
                        previewUrl ||
                        form.getFieldValue("image") ||
                        profileDetail?.user?.image
                      }
                      className="rounded-full"
                      height={64}
                      width={64}
                    />
                  ) : (
                    <Avatar
                      size={64}
                      icon={<BiUser />}
                      className="border-none bg-[#ba7d13]"
                    />
                  )}

                  <Upload
                    maxCount={1}
                    onRemove={() => {
                      setImage([]);
                      form.setFieldValue("image", null);
                    }}
                    listType="picture"
                    accept=".jpg, .jpeg, .png"
                    fileList={image}
                    customRequest={handleCustomReq}
                    showUploadList={false}
                  >
                    <Button
                      className="bg-[#ba7d13] absolute items-center rounded-full w-5 text-white border-none font-medium "
                      icon={<PiCameraPlusLight />}
                    >
                      {/* {form.getFieldValue("image") || profileDetail?.user?.image
                        ? "Change Image"
                        : "Upload Image"} */}
                    </Button>
                  </Upload>
                </div>

                <div className="mt-12">
                  <Form
                    form={form}
                    onFinish={(val) => handleUpdate(val)}
                    onFinishFailed={(err) => console.log(err)}
                    ref={formref}
                  >
                    <Form.Item
                      name="name"
                      className="mt-2"
                      labelCol={{ span: 24 }}
                      rules={[
                        {
                          required: true,
                          message: "Enter fullname ",
                        },
                      ]}
                    >
                      <Input
                        className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                        placeholder="Full Name"
                      />
                    </Form.Item>
                    <Form.Item
                      name="email"
                      className="mt-2"
                      labelCol={{ span: 24 }}
                      rules={[
                        { required: true, message: "Enter Email Address" },
                        {
                          type: "email",
                          message: "Enter a valid Email Address",
                        },
                      ]}
                    >
                      <Input
                        className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                        placeholder="Email Address"
                      />
                    </Form.Item>
                    <Form.Item
                      name="mobile"
                      className="mt-2"
                      labelCol={{ span: 24 }}
                      rules={[
                        {
                          required: true,
                          message: "Enter Mobile Number ",
                        },
                      ]}
                    >
                      <Input
                        className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                        placeholder="Mobile Number"
                        onChange={(e) => setMobile(e.target.value)}
                        value={mobile}
                        maxLength={10}
                      />
                    </Form.Item>
                    <Form.Item
                      name="referral_code"
                      className="mt-2"
                      labelCol={{ span: 24 }}
                      rules={[
                        {
                          required: true,
                          message: "Enter Refer Code",
                        },
                        {
                          pattern: /^[A-Za-z0-9]{6,10}$/,
                          message:
                            "Refer Code must be 6–10 alphanumeric characters",
                        },
                      ]}
                    >
                      <Input
                        className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                        placeholder="Refer Code"
                      />
                    </Form.Item>
                    <Form.Item
                      name="aadhar_no"
                      className="mt-2"
                      labelCol={{ span: 24 }}
                      rules={[
                        {
                          required: true,
                          message: "Enter Bank Aadhar Number",
                        },
                        {
                          pattern: /^[2-9]{1}[0-9]{11}$/,
                          message: "Enter a valid 12-digit Aadhaar number",
                        },
                      ]}
                    >
                      <Input
                        className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                        placeholder=" Aadhar Number"
                        maxLength={18}
                      />
                    </Form.Item>

                    <Form.Item
                      name="bank"
                      className="mt-2"
                      labelCol={{ span: 24 }}
                      rules={[
                        { required: true, message: "Enter Bank Name" },
                        {
                          pattern: /^[A-Za-z ]{3,50}$/,
                          message: "Bank Name should be 3–50 letters only",
                        },
                      ]}
                    >
                      <Input
                        className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                        placeholder="Bank Name"
                      />
                    </Form.Item>
                    <Form.Item
                      name="ac_holder_name"
                      className="mt-2"
                      labelCol={{ span: 24 }}
                      rules={[
                        {
                          required: true,
                          message: "Enter Account Holder  Name",
                        },
                      ]}
                    >
                      <Input
                        className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                        placeholder="Account Holder  Name"
                      />
                    </Form.Item>
                    <Form.Item
                      name="ac_no"
                      className="mt-2"
                      labelCol={{ span: 24 }}
                      rules={[
                        {
                          required: true,
                          message: "Enter Bank Account Number",
                        },
                        {
                          pattern: /^\d{9,18}$/,
                          message: "Account number must be 9–18 digits",
                        },
                      ]}
                    >
                      <Input
                        className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                        placeholder="Bank Account Number"
                        maxLength={18}
                      />
                    </Form.Item>

                    <Form.Item
                      name="ifsc_code"
                      className="mt-2"
                      labelCol={{ span: 24 }}
                      rules={[
                        { required: true, message: "Enter IFSC Code" },
                        {
                          pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                          message:
                            "Enter a valid IFSC Code (e.g., SBIN0123456)",
                        },
                      ]}
                    >
                      <Input
                        className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                        placeholder="IFSC Code"
                        maxLength={11}
                      />
                    </Form.Item>

                    <Form.Item
                      name="upi_id"
                      className="mt-2"
                      labelCol={{ span: 24 }}
                      rules={[
                        { required: true, message: "Enter UPI ID" },
                        {
                          pattern: /^[\w.-]+@[\w.-]+$/,
                          message: "Enter a valid UPI ID (e.g., name@bank)",
                        },
                      ]}
                    >
                      <Input
                        className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                        placeholder="UPI ID"
                      />
                    </Form.Item>

                    <Form.Item className="text-center">
                      <Button
                        // loading={loading}
                        htmlType="submit"
                        className="w-3/4  custome rounded-3xl h-10 font-medium text-lg border-none
                      text-white bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f]
                        hover:bg-gradient-to-r hover:from-[#734e0c] hover:via-[#ba7d13] hover:to-[#e9a52f]"
                      >
                        Submit
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
